import React, { Fragment, useState, useCallback } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  Popover,
  PopoverHeader,
  PopoverBody,
  UncontrolledPopover
} from "reactstrap";

export default function PopoverPage() {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [popoverTop, setPopoverTop] = useState(false);
  const [popoverBottom, setPopoverBottom] = useState(false);
  const [popoverLeft, setPopoverLeft] = useState(false);
  const [popoverRight, setPopoverRight] = useState(false);

  const toggleright = useCallback(() => {
    setPopoverRight((v) => !v);
  }, []);

  const toggleleft = useCallback(() => {
    setPopoverLeft((v) => !v);
  }, []);

  const togglebottom = useCallback(() => {
    setPopoverBottom((v) => !v);
  }, []);

  const toggletop = useCallback(() => {
    setPopoverTop((v) => !v);
  }, []);

  const toggle = useCallback(() => {
    setPopoverOpen((v) => !v);
  }, []);

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer
            heading={<IntlMessages id="menu.popover" />}
          />
          <Separator className="mb-5" />
        </Colxx>
      </Row>

      <Row>
        <Colxx xxs="12">
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="popover.examples" />
              </CardTitle>
              <div>
                <Button color="primary" id="Popover1" type="button">
                  Launch Popover
                </Button>
                <Popover
                  placement="bottom"
                  isOpen={popoverOpen}
                  target="Popover1"
                  toggle={toggle}
                >
                  <PopoverHeader>Popover Title</PopoverHeader>
                  <PopoverBody>
                    Sed posuere consectetur est at lobortis. Aenean eu leo
                    quam. Pellentesque ornare sem lacinia quam venenatis
                    vestibulum.
                  </PopoverBody>
                </Popover>
                <p>
                  {" "}
                  <Button
                    className="my-2 mr-2"
                    color="info"
                    id="PopoverFocus"
                    type="button"
                  >
                    Launch Popover (Focus)
                  </Button>{" "}
                  <Button
                    className="my-2 mr-2"
                    color="secondary"
                    id="PopoverClick"
                    type="button"
                  >
                    Launch Popover (Click)
                  </Button>{" "}
                  <Button
                    className="my-2 mr-2"
                    color="warning"
                    id="PopoverLegacy"
                    type="button"
                  >
                    Launch Popover (Legacy)
                  </Button>
                  <UncontrolledPopover
                    trigger="focus"
                    placement="bottom"
                    target="PopoverFocus"
                  >
                    <PopoverHeader>Focus Trigger</PopoverHeader>
                    <PopoverBody>
                      Focusing on the trigging element makes this popover
                      appear. Blurring (clicking away) makes it disappear. You
                      cannot select this text as the popover will disappear
                      when you try.
                    </PopoverBody>
                  </UncontrolledPopover>
                  <UncontrolledPopover
                    trigger="click"
                    placement="bottom"
                    target="PopoverClick"
                  >
                    <PopoverHeader>Click Trigger</PopoverHeader>
                    <PopoverBody>
                      Clicking on the triggering element makes this popover
                      appear. Clicking on it again will make it disappear. You
                      can select this text, but clicking away (somewhere other
                      than the triggering element) will not dismiss this
                      popover.
                    </PopoverBody>
                  </UncontrolledPopover>
                  <UncontrolledPopover
                    trigger="legacy"
                    placement="bottom"
                    target="PopoverLegacy"
                  >
                    <PopoverHeader>Legacy Trigger</PopoverHeader>
                    <PopoverBody>
                      Legacy is a reactstrap special trigger value (outside of
                      bootstrap's spec/standard). Before reactstrap correctly
                      supported click and focus, it had a hybrid which was
                      very useful and has been brought back as
                      trigger="legacy". One advantage of the legacy trigger is
                      that it allows the popover text to be selected while
                      also closing when clicking outside the triggering
                      element and popover itself.
                    </PopoverBody>
                  </UncontrolledPopover>
                </p>
              </div>
            </CardBody>
          </Card>
        </Colxx>
        <Colxx xxs="12">
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="popover.placements" />
              </CardTitle>
              <Button
                className="mr-2 my-2"
                color="secondary"
                id="popoverTop"
                type="button"
              >
                <IntlMessages id="popover.top" />
              </Button>
              <Popover
                placement="top"
                isOpen={popoverTop}
                target="popoverTop"
                toggle={toggletop}
              >
                <PopoverHeader>Popover Title</PopoverHeader>
                <PopoverBody>
                  Sed posuere consectetur est at lobortis. Aenean eu leo quam.
                  Pellentesque ornare sem lacinia quam venenatis vestibulum.
                </PopoverBody>
              </Popover>

              {/* Popover Bottom */}

              <Button
                className="mr-2 my-2"
                color="info"
                id="popoverBottom"
                type="button"
              >
                <IntlMessages id="popover.bottom" />
              </Button>
              <Popover
                placement="bottom"
                isOpen={popoverBottom}
                target="popoverBottom"
                toggle={togglebottom}
              >
                <PopoverHeader>Popover Title</PopoverHeader>
                <PopoverBody>popover content...</PopoverBody>
              </Popover>

              {/* Popover Left */}

              <Button
                className="mr-2 my-2"
                color="warning"
                id="popoverLeft"
                type="button"
              >
                <IntlMessages id="popover.left" />
              </Button>
              <Popover
                placement="left"
                isOpen={popoverLeft}
                target="popoverLeft"
                toggle={toggleleft}
              >
                <PopoverHeader>Popover Title</PopoverHeader>
                <PopoverBody>
                  Sed posuere consectetur est at lobortis. Aenean eu leo quam.
                  Pellentesque ornare sem lacinia quam venenatis vestibulum.
                </PopoverBody>
              </Popover>

              {/* Popover Right */}

              <Button
                className="mr-2 my-2"
                color="danger"
                id="popoverRight"
                type="button"
              >
                <IntlMessages id="popover.right" />
              </Button>
              <Popover
                placement="right"
                isOpen={popoverRight}
                target="popoverRight"
                toggle={toggleright}
              >
                <PopoverHeader>Popover Title</PopoverHeader>
                <PopoverBody>
                  Sed posuere consectetur est at lobortis. Aenean eu leo quam.
                  Pellentesque ornare sem lacinia quam venenatis vestibulum.
                </PopoverBody>
              </Popover>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    </Fragment>
  );
}
